import React from "react";

function Header({ data }) {
  return (
    <div className="row mt-5 clup_slider">
      <div
        id="carouselExampleDark"
        className="carousel carousel-dark slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-indicators">
          {data &&
            data.map((image, i) => {
              return (
                <button
                  key={i}
                  type="button"
                  data-bs-target="#carouselExampleDark"
                  data-bs-slide-to={i}
                  aria-label={"Slide " + (i + 1)}
                  aria-current={i == 0 ? "true" : "false"}
                  className={i == 0 ? "active" : ""}
                />
              );
            })}
        </div>
        <div className="carousel-inner">
          {data &&
            data.map((image, i) => {
              return (
                <div
                  key={i}
                  className={`carousel-item ${i === 0 ? "active" : ""}`}
                >
                  <img
                    className="d-block "
                    src={image}
                    alt={"عکس کلاب شماره" + i}
                  />
                </div>
              );
            })}
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleDark"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true" />
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleDark"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true" />
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
}
export default Header;
